function cookie_grab(phrase) {
	var location = document.cookie.split("=");
	for (var loop = 0; loop < location.length; loop++) {
		var split_location = location[loop];
		var regex = new RegExp(phrase);
		if (regex.test(split_location) == true) {
			var integer = loop + 1;
			var the_number = location[integer];
			this.number = the_number.split(";")[0];
			var coord = this.number.split(":");
			this.longitude = coord[0];
			this.latitude = coord[1];
		}
	}
}

function cookie_function() {
	var my_cookie = new cookie_grab('turnoff');
	var cookie_value = my_cookie.number;
	if (cookie_value == undefined) {
		jQuery('.cookie-menu-item').remove();
		var division = document.createElement('div');
		var text = document.createTextNode('This site uses tracking cookies, for info on data privacy please read the  ')
		division.appendChild(text);
		division.setAttribute('id', 'cookie_jar');
		var aElem = document.createElement('a');
		aElem.href = "https://prayerwithbeads.com/privacy-policy/";
		aElem.style.color = '#ffffff';
		aElem.style.textDecoration = 'underline !important';
		var aElemTN = document.createTextNode('privacy policy');
		aElem.appendChild(aElemTN);
		division.appendChild(aElem);
		var text = document.createTextNode(' ')
		division.appendChild(text);
		/* Button One */
		var aElem = document.createElement('input');
		aElem.setAttribute("type", "button");
		aElem.setAttribute("value", "allow tracking");
		aElem.setAttribute("id", "b_2");
		aElem.setAttribute("onclick", "set_cookie('yes');return false");
		aElem.style.color = '#ffffff';
		aElem.style.backgroundColor = '#36af0e';
		aElem.style.borderColor = 'transparent';
		aElem.style.padding = '0px 10px';
		aElem.style.lineHeight = '2.5';
		division.appendChild(aElem);
		/* Button Two */
		var aElem = document.createElement('input');
		aElem.setAttribute("type", "button");
		aElem.setAttribute("value", "block tracking");
		aElem.setAttribute("id", "b_3");
		aElem.setAttribute("onclick", "set_cookie('no');return false");
		aElem.style.color = '#ffffff';
		aElem.style.backgroundColor = 'red';
		aElem.style.borderColor = 'transparent';
		aElem.style.padding = '0px 10px';
		aElem.style.lineHeight = '2.5';
		division.appendChild(aElem);
		var bdy = document.body;
		bdy.appendChild(division);
	}
	if (cookie_value != undefined) {
		var html = "<li><a href='#' onClick='cookienotice();return false;'>Cookie Settings</a></li>";
		jQuery('.footer-column-3 .menu').append(html);
	}
}

function cookienotice() {
	var my_cookie = new cookie_grab('tracking');
	var cookie_value = my_cookie.number;
	unset_cookie(cookie_value);
	var division = document.createElement('div');
	var text = document.createTextNode('This site uses tracking cookies, for info on data privacy please read the  ')
	division.appendChild(text);
	division.setAttribute('id', 'cookie_jar');
	var aElem = document.createElement('a');
	aElem.href = "https://prayerwithbeads.com/privacy-policy/";
	aElem.style.color = '#ffffff';
	aElem.style.textDecoration = 'underline !important';
	var aElemTN = document.createTextNode('privacy policy');
	aElem.appendChild(aElemTN);
	division.appendChild(aElem);
	var text = document.createTextNode(' ')
	division.appendChild(text);
	/* Button One */
	var aElem = document.createElement('input');
	aElem.setAttribute("type", "button");
	aElem.setAttribute("value", "allow tracking");
	aElem.setAttribute("id", "b_2");
	aElem.setAttribute("onclick", "set_cookie('yes');return false");
	aElem.style.color = '#ffffff';
	aElem.style.backgroundColor = '#36af0e';
	aElem.style.borderColor = 'transparent';
	aElem.style.padding = '0px 10px';
	aElem.style.lineHeight = '2.5';
	division.appendChild(aElem);
	/* Button Two */
	var aElem = document.createElement('input');
	aElem.setAttribute("type", "button");
	aElem.setAttribute("value", "block tracking");
	aElem.setAttribute("id", "b_3");
	aElem.setAttribute("onclick", "set_cookie('no');return false");
	aElem.style.color = '#ffffff';
	aElem.style.backgroundColor = 'red';
	aElem.style.borderColor = 'transparent';
	aElem.style.padding = '0px 10px';
	aElem.style.lineHeight = '2.5';
	division.appendChild(aElem);
	var bdy = document.body;
	bdy.appendChild(division);
	jQuery('.cookie-menu-item').remove();
}
function unset_cookie(cookie) {
	var now = new Date();
	var time = now.getTime();
	var expiry = time - 1209600000;
	var end_time = new Date(expiry);
	var start_time = end_time.toUTCString();
	/* Unset Cookies */
	var the_cookie = "turnoff=on;path=/;domain=;expires=" + start_time;
	document.cookie = the_cookie;
	var the_cookie = "tracking=" + cookie + ";path=/;domain=prayerwithbeads.com;expires=" + start_time;
	document.cookie = the_cookie;
}
function set_cookie(cookie) {
	var now = new Date();
	var time = now.getTime();
	var expiry = time + 1209600000;
	var end_time = new Date(expiry);
	var start_time = end_time.toUTCString();
	/* Turn Off Cookie Banner */
	var the_cookie = "turnoff=on;path=/;domain=prayerwithbeads.com;expires=" + start_time;
	document.cookie = the_cookie;
	/* No Tracking */
	var the_cookie = "tracking=" + cookie + ";path=/;domain=prayerwithbeads.com;expires=" + start_time;
	document.cookie = the_cookie;
	var parent = document.body;
	var child = document.getElementById("cookie_jar");
	parent.removeChild(child);
	var html = "<li class='cookie-menu-item'><a href='#' onClick='cookienotice();return false;'>Cookie Settings</a></li>";
	jQuery('.footer-column-3 .menu').append(html);
}

window.cookie_function = cookie_function;
window.cookienotice = cookienotice;
window.set_cookie = set_cookie;